import { render } from "./DropShipsView.vue?vue&type=template&id=4b6e89f8&scoped=true"
import script from "./DropShipsView.vue?vue&type=script&lang=js"
export * from "./DropShipsView.vue?vue&type=script&lang=js"

import "./DropShipsView.vue?vue&type=style&index=0&id=4b6e89f8&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6e89f8"]])

export default __exports__